<script>
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import TechnicianSetting from './TechnicianSetting.vue'
import CoordinatorSetting from './CoordinatorSetting.vue'

export default {
  page: {
    title: 'Notification Settings',
    meta: [{ name: 'description', content: 'Pengaturan Notifikasi' }],
  },
  components: {
    Layout,
    TechnicianSetting,
    CoordinatorSetting,
  },
  mixins: [Helper],

  computed: {
    isTechnician() {
      return (
        Number(this.$store?.state?.users?.user?.position_id) ===
        Number(process.env.VUE_APP_TECHNICIAN_POSITION_ID)
      )
    },
  },
}
</script>

<template>
  <Layout>
    <TechnicianSetting v-if="isTechnician" />
    <CoordinatorSetting v-else />
  </Layout>
</template>